<style>
    .sml-stl {
        border-bottom: 1px solid #ddd;
        padding-bottom: 20px;
        position: relative;
    }
    .sml-stl::after {
        content: 'OR';
        position: absolute;
        bottom: -14px;
        left: 50%;
        margin-left: -25px;
        width: 50px;
        text-align: center;
        background: #f0f0f0;
        color: #ddd;
    }
    
    form#AuthComponent .action-buttons-stl,
    form#AuthLoginComponent .action-buttons-stl {
        margin-top: 25px;
    }   
    form#AuthLoginComponent .ivu-form-item-content .auth-footer,
    form#AuthLoginComponent .ivu-form-item-content .auth-footer a, 
    form#AuthComponent .ivu-form-item-content .auth-footer,
    form#AuthComponent .ivu-form-item-content .auth-footer a { 
        line-height: 25px;
        font-size: 18px;
    }
    form#AuthLoginComponent .ivu-form-item-content .auth-footer a,
    form#AuthComponent .ivu-form-item-content .auth-footer a {
        font-weight: bolder;
    }
    form#AuthLoginComponent,
    form#AuthComponent {
        padding: 15px 0;
        margin-top: 20px;
    }
    form#AuthLoginComponent .ivu-form-item,
    form#AuthComponent .ivu-form-item {
        margin-bottom: 20px;
    }
    form#AuthLoginComponent .ivu-form-item-error-tip,
    form#AuthComponent .ivu-form-item-error-tip {
        font-size: 12px;
        top: 32px;
    }
</style>

<template>
    <Row type="flex" justify="center">
        <Col span="18">
            <h3 align="center" style="margin:15px 0;">{{(authType === 'signin') ? 'Welcome':'Account Registration'}}</h3>
       
            <div class="sml-stl" v-if="isSamlEnable">
                <Button type="primary" size="large" @click="redirectSSO" long>{{samlText}}</Button>
            </div>

            <Form v-show="authType === 'signin'" id="AuthLoginComponent" ref="formLoginCustom" :model="formLoginCustom" :rules="ruleLoginCustom" :label-width="0">
                <FormItem prop="username">
                    <Input size="large" placeholder="Username / Email / Mobile" type="text" @on-enter="handleSubmit('formLoginCustom')" v-model="formLoginCustom.username" />
                </FormItem>
                <FormItem prop="passwd">
                    <Input size="large" placeholder="Password" type="password" @on-enter="handleSubmit('formLoginCustom')" v-model="formLoginCustom.passwd" />
                </FormItem>
                <FormItem class="action-buttons-stl">
                    <Button type="primary" size="large" :loading="isAuthenticating" long @click="handleSubmit('formLoginCustom')">Login</Button>
                    <router-link tag="p" to="/forgot-password" style="margin-top:10px;">
                        <a style="font-size:16px;">Forgot Password?</a>
                    </router-link>
                </FormItem>
            </Form>

            <Form v-show="authType === 'signup'" id="AuthComponent" ref="formCustom" :model="formCustom" :rules="ruleCustom" :label-width="0">
                <FormItem prop="username">
                    <Input size="large" placeholder="Username" @on-enter="handleSubmit('formCustom')" type="text" v-model="formCustom.username" />
                </FormItem>
                <FormItem prop="passwd">
                    <Input size="large" placeholder="Password" @on-enter="handleSubmit('formCustom')" type="password" v-model="formCustom.passwd" />
                </FormItem>
                <FormItem prop="passwdCheck">
                    <Input size="large" placeholder="Re-Type Password" type="password"@on-enter="handleSubmit('formCustom')"  v-model="formCustom.passwdCheck" /> 
                </FormItem>
                <FormItem class="action-buttons-stl">
                    <Button type="primary" size="large" :loading="isAuthenticating" long @click="handleSubmit('formCustom')">Register</Button>
                </FormItem>
            </Form>

            <Form :label-width="0">
                <FormItem>
                    <p align="center" class="auth-footer">
                        {{(authType === 'signup') ? "Already have an account?" : "Dont have an account?"}} <a @click="changeMethods()">{{(authType === 'signup') ? 'Login' : 'Register'}}</a>
                    </p>
                    <p v-if="false" align="center" class="auth-footer">
                        Continue as <router-link :to="'/'+this.$route.params.brandSlug+'/home'">Guest</router-link>
                    </p>
                </FormItem>
            </Form>
        </Col>
    </Row>
</template>

<script>
import VueCookie from "vue-cookie";
import { mapGetters } from "vuex";
import Utils from "@/utils.js";
import store from "@/store";
import Axios from "axios";
import _ from "lodash";

export default {
    name: "AuthenticationComponent",
    data () {
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Please enter your password'));
            } else {
                if (this.formCustom.passwdCheck !== '') {
                    this.$refs.formCustom.validateField('passwdCheck');
                }
                callback();
            }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error('Please enter your password again'));
            } else if (value !== this.formCustom.passwd) {
                callback(new Error('The two input passwords do not match!'));
            } else {
                callback();
            }
        };
        const validateUsername = (rule, value, callback) => {
            if (!value) {
                return callback(new Error('Username cannot be empty'));
            }
            setTimeout(() => {
                if (value === '') {
                    callback(new Error('Please enter a value'));
                } 
                else if (value.includes(" ")) {
                    callback(new Error("Username should not contain spaces"));
                } 
                else {
                    if (value.length < 5) {
                        callback(new Error('Username must atleast 5 characters long'));
                    } else {
                        callback();
                    }
                }
            }, 1000);
        };
        const validateLoginUsername = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please enter either your Username/Email/Mobile'));
            } 
            else if (value.includes(" ")) {
                callback(new Error("Username/Email/Mobile should not contain spaces"));
            }
            setTimeout(() => {
                if (value === '') {
                    callback(new Error('Please enter either your Username/Email/Mobile'));
                } else {
                    callback();
                }
            }, 1000);
        };
        
        return {
            dialog: null,
            isAuthenticating: false,
            formCustom: {
                passwd: '',
                passwdCheck: '',
                username: ''
            },
            formLoginCustom: {
                passwd: '',
                username: ''
            },
            ruleCustom: {
                passwd: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                passwdCheck: [
                    { validator: validatePassCheck, trigger: 'blur' }
                ],
                username: [
                    { validator: validateUsername, trigger: 'blur' }
                ]
            },
            ruleLoginCustom: {
                passwd: [
                    { validator: validatePass, trigger: 'blur' }
                ],
                username: [
                    { validator: validateLoginUsername, trigger: 'blur' }
                ]
            },
            fbLoginUrl: null
        }
    },
    computed: {
        ...mapGetters("user", ["brandInfo", "userInfo"]),
        redirectLink() {
        return _.get(this.$route, "query.redirect")
        },
        token() {
        return _.get(this.$route, "query.token")
        },
        authType() {
            return (this.$route.query && this.$route.query.type) ? `${this.$route.query.type}` : `signin`;
        },
        tempNumber() {
            return this.$store.state.base.VCodeMobile;
        },
        verified() {
            return this.$store.state.base.VCodeVerified;
        },
        isSigning() {
            return this.$store.state.base.isAuthenticating;
        },
        isSamlEnable() {
            return (this.brandInfo && this.brandInfo.saml && this.brandInfo.enable_saml);
        },
        samlText() {
            return `Login with ${ _.get(this.brandInfo, 'saml.name', '') }`;
        }
    },
    methods: {
        redirectSSO() {
            if( VueCookie.get("os_type") === "ios" ) {
                window.webkit.messageHandlers.onNativeCalled.postMessage({
                    name: "showSamlLoginScreen",
                    params: {
                        type: this.authType
                    }
                });
            } else {
                this.dialog = window.open(
                    this.brandInfo.saml.login_url,
                    '_blank',
                    'width=340,height=600'
                );
            }
        },
        changeMethods() {
            if ( this.authType === 'signup') 
                this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signin`) 
            else 
                this.$router.replace(`/${this.$route.params.brandSlug}/login?type=signup`) 

            setTimeout( () => {
                this.handleReset('formCustom');
                this.handleReset('formLoginCustom');
            }, 500)
        },
        handleSubmit (name) {
          this.$refs[name].validate((valid) => {
            if (valid) {
              grecaptcha.ready(() => {
                grecaptcha
                  .execute(process.env.VUE_APP_CAPTCHA_KEY, {
                    action: "submit",
                  })
                  .then((token) => {
                    console.log({ token });
                    this.onSignInit(token);
                  });
              });
            }
          });
        },
        handleReset (name) {
            this.$refs[name].resetFields();
        },
        vlfInit() {
            this.$vlf
                .createInstance({storeName: "systemAlert"})
                .then(v => {
                    v.setItem("shareableActivity", {});
                    v.setItem("showAlert", true);
                });
        },
        storeClearing(v) {
            v.removeItem("code");
            v.removeItem("mobile");
            v.removeItem("isVerified");
            store.commit("base/setVCode", null);
            store.commit("base/setVCodeMobile", null);
            store.commit("base/setVCodeVerified", false);
            VueCookie.delete("PRESCRIPTION_CODE");
            VueCookie.delete("PRESCRIPTION_MOBILE");
        },
        vlfInitHumanityRegister() {
            this.$vlf
                .createInstance({storeName: "humanity"})
                .then((v) => {
                    this.storeClearing()
                    this.register = _.cloneDeep(Cons[0].REGISTER);
                    setTimeout(() => {
                        this.isAuthenticating = false;
                        this.$router.push(
                          `/${this.$route.params.brandSlug}/onboarding`
                        );
                        this.$store.commit("base/setLoadingPage", false, {
                          root: 1
                        });
                        this.isSuccessRegister = true;
                    }, 4000);
                })
                .catch((error) => {
                    this.isSuccessRegister = false;
                    this.isAuthenticating = false;
                    this.$store.commit("base/setLoadingPage", false, {root: 1});
                });
        },
        vlfInitHumanity() {
            this.$vlf
                .createInstance({storeName: "humanity"})
                .then((v) => {
                    this.isAuthenticating = false;
                    this.storeClearing()
                })
                .catch((e) => {
                    this.$Spin.hide();
                    this.isAuthenticating = false;
                });
        },
        returnSSO(e) {
            if (e && this.dialog !== null) {
                var date = new Date(e.data.token.expires_at);
                var seconds = date.getTime() / 1000;

                var ndata = {
                    token_type: "Bearer",
                    expires_in: seconds,
                    access_token: e.data.accessToken
                }

                localStorage.removeItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
                VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_COURSE`);
                VueCookie.delete(`${Cons[0].PATHS.NAME}${Cons[0].PATHS.BRAND}VISITED_ARTICLE`);
                this.$store.commit('base/setUserAuth', ndata, {root:1})

                localStorage.setItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE', JSON.stringify(ndata))
                let mCookie = localStorage.getItem(Cons[0].PATHS.NAME + Cons[0].PATHS.BRAND + 'COOKIE')
                let uCookie = JSON.parse(mCookie)

                Axios.defaults.headers.common['Authorization'] = null
                Axios.defaults.headers.common['Authorization'] = 'Bearer ' + uCookie.access_token

                this.$store.dispatch('user/getUserInfo', null, {root:1})
                    .then( res => {
                        this.dialog.close();
                        setTimeout(() => {
                            this.$router.replace(`/${this.$route.params.brandSlug}/home`);
                        }, 2000);
                    })
                    .catch( e => {
                        this.dialog.close();
                    });
            }
        },
        onSignInit(token) {
            let { pType, code, prescription } = this.$route.query;
            let prescriptionType = pType ? pType : null;
            let brandPrescriptionCode = code ? code : null;
            let groupPrescriptionCode = prescription ? prescription : null;

            switch(this.authType) {
                case "signup":
                    let rData = _.cloneDeep(Cons[0].REGISTER);
                    let registerData = { ...rData };
                    let { key } = this.$route.query;
                    let branding_doctor_id = null;
                    let invite_code = null;

                    if ( prescriptionType ) {
                        if (prescriptionType == 'brand' && brandPrescriptionCode)
                            registerData = {
                                ...rData,
                                branding_doctor_id: brandPrescriptionCode
                            }
                        else if (prescriptionType == 'group' && groupPrescriptionCode)
                            VueCookie.set(Cons[0].PATHS.NAME + "PLAN_PRESCRIPTION", JSON.stringify(groupPrescriptionCode));
                    }

                    let pCode = VueCookie.get("PRESCRIPTION_CODE");
                    if ( pCode ) {
                        registerData = {
                            ...rData,
                            invite_code: pCode
                        }
                    }

                    delete registerData.display_name;
                    delete registerData.user_type;
                    delete registerData.first_name;
                    delete registerData.last_name;
                    delete registerData.email;
                    delete registerData.contact_number;

                    if ( key ) {
                        this.isAuthenticating = true;
                        this.$store
                            .dispatch("base/registerByKey", { data: {
                                ...registerData,
                                username: this.formCustom.username,
                                password: this.formCustom.passwd,
                                token,
                            } })
                            .then((res, data) => {
                                this.vlfInitHumanity()
                            }).catch((e) => {
                                this.isAuthenticating = false
                            });
                    } else {
                        this.isAuthenticating = true;
                        this.$store.commit("base/setLoadingPage", true, { root: 1 });
                        this.$store
                            .dispatch("base/register", { data: {
                                ...registerData,
                                username: this.formCustom.username,
                                password: this.formCustom.passwd,
                                token,
                            }, reroute: true })
                            .then((res, data) => {
                                this.vlfInitHumanityRegister();
                            }).catch((e) => {
                                this.$store.commit("base/setLoadingPage", false, {root: 1});
                                this.isAuthenticating = false;
                            });
                    }
           
                    break;
                default: 
                    const { uname: username, pwd: passwd } = this.formLoginCustom;

                    if ( prescriptionType ) {
                        if (prescriptionType == 'brand' && brandPrescriptionCode)
                            VueCookie.set(Cons[0].PATHS.NAME + "PRESCRIPTION", JSON.stringify(groupPrescriptionCode));
                        else if (prescriptionType == 'group' && groupPrescriptionCode)
                            VueCookie.set(Cons[0].PATHS.NAME + "PLAN_PRESCRIPTION", JSON.stringify(groupPrescriptionCode));
                    }

                    this.isAuthenticating = true;
                    this.$store
                        .dispatch("base/authenticate", { response: {
                            password: this.formLoginCustom.passwd,
                            username: this.formLoginCustom.username,
                            token,
                        }})
                        .then(res => {
                            this.isAuthenticating = false;
                            this.vlfInit();
                        })
                        .catch(error => {
                            this.isAuthenticating = false;
                        });

                    break;
            }
        }
    },
    created() {
        this.$store.dispatch("base/getFacebookLink").then(res => {
            this.fbLoginUrl = res;
        });
    },
    mounted() {
        if ( this.userInfo && (this.userInfo.user_type === 'member' || this.userInfo.user_type === 'admin') && !this.redirectLink && !this.token) 
            this.$router.replace(`/${this.$route.params.brandSlug}/home`);
        else 
            if ( VueCookie.get('os_type') === "ios" && !VueCookie.get('ios_app_version') ) {
                window.webkit.messageHandlers.onNativeCalled.postMessage({
                    name: 'authLogin',
                    params: {}
                })
                return false;
            }

        setTimeout( () => {
            this.handleReset('formCustom');
            this.handleReset('formLoginCustom');
        }, 500)

        window.addEventListener("message", this.returnSSO, false);
    }
}
</script>